import React from "react";

class RadioCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: this.props.value || null,
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(optionValue, checked, id) {
        let selectedValue = this.state.selectedValue;
        const radioButton = document.getElementById(id);

        if (selectedValue && selectedValue === optionValue && checked) {
            radioButton.checked = false;
            selectedValue = null;
        } else {
            selectedValue = optionValue;
        }

        this.setState({ selectedValue });
        this.props.onChange(selectedValue);
    }

    render() {
        const { options, keyName } = this.props;
        if (!options || options.length === 0) {
            return "";
        }

        return (
            <div className="flex flex-row flex-wrap gap-2" key={keyName}>
                {options.map((option, index) => {
                    const isSelected = this.state.selectedValue === option.value;
                    return (
                        <button
                            type="button"
                            key={index}
                            lang="fr"
                            translate="yes"
                            className={`px-4 py-2 rounded-[11px] text-sm font-medium border transition-all cursor-pointer ${isSelected ? "text-white border-transparent" : "text-gray-600 bg-white hover:border-gray-300"}`}
                            style={isSelected ? { backgroundColor: "var(--primary-color)" } : { borderColor: '#e7eaef' }}
                            onClick={() => {
                                const newVal = this.state.selectedValue === option.value ? null : option.value;
                                this.setState({ selectedValue: newVal });
                                this.props.onChange(newVal);
                            }}
                        >
                            <span lang="fr" translate="yes">{option.label}</span>
                        </button>
                    );
                })}
            </div>
        );
    }
}

export default RadioCheckbox;